// staticEventData.js

export const staticEventData = {
    "id": 15,
    "ref_evenement": "EVT-00015-ADMIN01",
    "titre": "Conférence Internationale sur l'Intelligence Artificielle 2026",
    "description": "Une conférence majeure réunissant les experts mondiaux de l'IA pour discuter des dernières avancées en matière d'apprentissage automatique, de deep learning et d'éthique de l'IA. Au programme : keynotes, ateliers pratiques, panels de discussion et networking.",
    "visibilite": "Public",
    "cotisation": false,
    "date_debut_evenement": "2026-06-15T09:00:00Z",
    "date_fin_evenement": "2026-06-17T18:00:00Z",
    "photo_evenement": "https://media.gettyimages.com/id/1486287149/fr/photo/groupe-de-participants-daffaires-asiatiques-multiraciaux-conversation-informelle-apr%C3%A8s-un.jpg?s=612x612&w=gi&k=20&c=3crCKtwldS0uVqobKypaM-NMkt60K7yBsMMoSsVscnc=",
    "statut_evenement": "1",
    "nom_lieu": "Palais des Congrès de Cotonou",
    "longitude": "2.39123",
    "latitude": "6.37029",
    "description_lieu": "Grande salle polyvalente, 1er étage, équipée de vidéoprojecteur et sonorisation",
    "date_creation": "2026-04-20T08:00:00Z",
    "date_modification": "2026-04-25T10:30:00Z",
    "categorie": {
        "id": 3,
        "ref_categorie": "CAT-00003",
        "nom": "Technologie / Innovation"
    },
    "organisateur": {
        "id": 1,
        "ref_compte": "CPT-00001",
        "pseudo": "Traoré JOHN",
        "email": "admin@showtime.com",
        "nom": "ADMIN",
        "prenoms": "Showtime"
    },
    "collaborateurs": [
        {
            "id": 101,
            "ref_compte": "CPT-00101",
            "pseudo": "marie_konan",
            "nom": "KONAN",
            "prenoms": "Marie",
            "telephone": "+2250707123456",
            "email": "marie.konan@email.com",
            "type_collaboration": "2",
            "type_label": "Comité d'organisation",
            "statut_collaboration": "2",
            "statut_label": "Actif"
        },
        {
            "id": 102,
            "ref_compte": "CPT-00102",
            "pseudo": "jean_kouassi",
            "nom": "KOUASSI",
            "prenoms": "Jean",
            "telephone": "+2250707123457",
            "email": "jean.kouassi@email.com",
            "type_collaboration": "1",
            "type_label": "Comité de contrôle",
            "statut_collaboration": "2",
            "statut_label": "Actif"
        },
        {
            "id": 103,
            "ref_compte": "CPT-00103",
            "pseudo": "amadou_traore",
            "nom": "TRAORE",
            "prenoms": "Amadou",
            "telephone": "+2250707123458",
            "email": "amadou.traore@email.com",
            "type_collaboration": "3",
            "type_label": "Contrôle + Organisation",
            "statut_collaboration": "1",
            "statut_label": "Invité"
        },
        {
            "id": 104,
            "ref_compte": null,
            "pseudo": null,
            "nom": "DIALLO",
            "prenoms": "Fatou",
            "telephone": "+2250707123459",
            "email": null,
            "type_collaboration": "2",
            "type_label": "Comité d'organisation",
            "statut_collaboration": "1",
            "statut_label": "Invité"
        }
    ]
};